import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData, ContextOptions } from "@utils/api-config/types";

export default class KeepAliveApiService {
	static baseUrl = `${WEBPACK_BASE_ADDRESS}platform/keep-alive`;

	static getRequestHeaders(context: ApiRequestContextData) {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		appHeaders["Accept" as keyof HeadersInit] = "application/json";
		return appHeaders;
	}

	static ping(options: ContextOptions): Promise<any> {
		const context = getApiRequestContext(options);

		return httpClient.get(this.baseUrl, this.getRequestHeaders(context), {
			responseType: "raw",
		});
	}
}
